export const FONT_FAMILY_OPTIONS = [
  { label: "Style du site", value: "" },
  { label: "System sans", value: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif" },
  { label: "Helvetica", value: "Helvetica Neue, Arial, sans-serif" },
  { label: "Arial", value: "Arial, sans-serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Times", value: "Times New Roman, Times, serif" },
  { label: "Impact", value: "Impact, Haettenschweiler, Arial Narrow Bold, sans-serif" },
  { label: "Monospace", value: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" },
];

export const TYPOGRAPHY_TARGETS = [
  { key: "homeNewsTitle", group: "Accueil", label: "News hero - titre" },
  { key: "homeNewsText", group: "Accueil", label: "News hero - sous-titre" },
  { key: "homeYmsTitle", group: "Accueil", label: "YMS - titre" },
  { key: "homeYmsText", group: "Accueil", label: "YMS - description" },
  { key: "homeSessionTitle", group: "Accueil", label: "Unlimited Session - titre" },
  { key: "homeSessionText", group: "Accueil", label: "Unlimited Session - description" },
  { key: "homeLatdiorTitle", group: "Accueil", label: "Latdior accueil - titre" },
  { key: "homeLatdiorText", group: "Accueil", label: "Latdior accueil - description" },
  { key: "homeLatdiorButton", group: "Accueil", label: "Latdior accueil - boutons" },
  { key: "homeCoversTitle", group: "Accueil", label: "Pochettes accueil - titre" },
  { key: "newsTitle", group: "News", label: "Page News - titre" },
  { key: "newsCardTitle", group: "News", label: "Cartes News - titres" },
  { key: "newsCardText", group: "News", label: "Cartes News - textes" },
  { key: "studioTitle", group: "Studio", label: "Studio - titre hero" },
  { key: "studioText", group: "Studio", label: "Studio - description" },
  { key: "servicesTitle", group: "Services", label: "Services - titre" },
  { key: "servicesText", group: "Services", label: "Services - textes" },
  { key: "latdiorTitle", group: "Latdior", label: "Page Latdior - titre" },
  { key: "latdiorText", group: "Latdior", label: "Page Latdior - textes" },
  { key: "legalTitle", group: "Mentions légales", label: "Mentions légales - titre" },
  { key: "legalSectionTitle", group: "Mentions légales", label: "Mentions légales - titres sections" },
  { key: "legalBody", group: "Mentions légales", label: "Mentions légales - corps de texte" },
];

export function typographyStyle(settings = {}) {
  const style = {};
  const fontFamily = settings.customFont || settings.fontFamily;
  if (fontFamily) style.fontFamily = fontFamily;
  if (settings.fontSize) style.fontSize = `${Number(settings.fontSize)}px`;
  if (settings.fontWeight) style.fontWeight = String(settings.fontWeight);
  if (settings.italic === true) style.fontStyle = "italic";
  if (settings.textAlign) style.textAlign = settings.textAlign;
  if (settings.lineHeight) style.lineHeight = String(settings.lineHeight);
  if (settings.letterSpacing !== undefined && settings.letterSpacing !== "") {
    style.letterSpacing = `${Number(settings.letterSpacing)}px`;
  }
  if (settings.textTransform) style.textTransform = settings.textTransform;
  return style;
}

export function typographyFor(site, key) {
  return typographyStyle(site?.typography?.[key] || {});
}
